import styled from 'styled-components';
import { Button } from '~/components';
import { HistoryGraphContainer, HistoryGraphLoading } from '../../styles';

export const CardsContainerLoading = styled(HistoryGraphLoading)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .skeleton-span {
    width: 500px;
  }
`;

export const WaterContainer = styled(CardsContainerLoading)<{ expanded: boolean }>`
  margin-top: 0;
  flex-direction: column;
  gap: 10px;
  align-items: start;
  justify-content: flex-start;

  ${({ expanded }) => (expanded ? `
    width: 100%;
  ` : '')}


  @media (max-width: 768px) {
    width: 100% !important;
  }
`;

export const WaterContainerLoading = styled(CardsContainerLoading)`
  @media (max-width: 768px) {
    width: 100%;

    .skeleton-span, .skeleton-container-span {
      width: 100%;
    }
  }
`;

export const WaterCardContainer = styled(HistoryGraphContainer)<{ expanded: boolean }>`
  gap: 14px;
  height: 364px;
  width: ${({ expanded }) => (expanded ? '100%' : '500px')};

  @media (max-width: 768px) {
    width: 100% !important;
  }
`;

export const CardsGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  flex: 1;
  gap: 8px;
`;

export const DetailsButton = styled(Button)`
  height: 25px;
  width: 92px;
`;

export const BadgeContainer = styled.div`
  margin-left: auto;
  position: absolute;
  top: 5px;
  right: 12px;
`;

export const EnergyContainer = styled(CardsContainerLoading)<{ expanded: boolean, loading: boolean }>`
  margin-top: 0;
  flex-direction: column;
  gap: 10px;
  align-items: start;
  justify-content: flex-start;

  & > div {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    ${({ expanded }) => (expanded ? `
      width: 100%;
    ` : '')}
  }

  ${({ expanded }) => (expanded ? `
    width: 100%;
  ` : '')}

  ${({ loading, expanded }) => (loading || !expanded ? '' : `
    flex: 1 1 100%;
  `)}

  @media (max-width: 768px) {
    & > div {
      flex-direction: column;
    }

    & > div:nth-child(1) {
      flex: 1;
      width: 100%;
    }
  }
`;

export const RowCardContainer = styled.div<{ direction: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  flex-wrap: wrap;
  gap: 16px;
`;
